module.exports = __webpack_public_path__ + "src/assets/games/54/A.png";